<template>
    <div id="gameHeader" class="fixed-game-header">
        <statusBar></statusBar>
        <div class="pages-header">
            <div @click="onNavBack">
                <i class="iconfont icon-xiangzuo"></i>
                <!-- <img class="logo" :src="logoUrl" @click.stop="toHome" /> -->
                <img v-if="device == 'mobile'" class="logo" style="height: .75rem;" :src="logoUrl2" @click.stop="toHome" />
                <img v-else class="logo" :src="logoUrl" @click.stop="toHome" />
            </div>
            <div class="user_action">
                <div></div>
                <div class="user_info">
                    <!-- <div class="CurrencyType"><span>{{ CurrencyType }}</span></div> -->
                    <!-- <div>
                        <div class="user_money">
                            <span style="margin-left: 4px;">{{ userInfo && userInfo.balanceAmtAccount ?
                                formatAmount(userInfo.balanceAmtAccount.useBalance, 1) : "0.0" }}</span>
                        </div>
                        <div class="user_account">
                            <span style="margin-left: 4px;">{{ userInfo && userInfo.bonusAmtAccount ?
                                formatAmount(userInfo.bonusAmtAccount.useBalance, 1) : "0.0" }}</span>
                        </div>
                    </div> -->
                    <div class="deposit deposit_app" @click.stop="toDeposit">+</div>
                    <div class="deposit deposit_PC" @click.stop="toDeposit">{{ $t("deposit.Deposit") }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import statusBar from '@/components/statusBar'
import { mapState } from 'vuex'
export default {
    name: 'gameHeader',
    components: { statusBar },
    data() {
        return {}
    },
    computed: {
        ...mapState({
            device: state => state.app.device
        }),
        logoUrl() {
            return this.$store.getters.sysConfig?.homeLogoUrl
        },
        logoUrl2() {
            return this.$store.getters.sysConfig?.homeImageUrl
        },
        userInfo() {
            return this.$store.getters.userInfo
        }
    },
    created() { },
    methods: {
        onNavBack() {
            this.$emit('onNavBack')
        },
        toHome() {
            this.$emit('toHome')
        },
        toDeposit() {
            const params = { type: 'deposit' }
            this.onNavTo({ url: '/wallet', type: 'get', params })
        }
    }
}
</script>

<style scoped lang="scss">
.fixed-game-header {
    width: 100%;
    position: relative;
    z-index: 98;
    box-shadow: 0 4px 20px var(--aurora-shadow-color);
    background:
        var(--aurora-soft-gradient);

    .pages-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0;
        padding-right: .2rem;
        height: 1rem;
        padding-right: .2rem;
        box-sizing: border-box;
        position: relative;
        padding-left: 300px;

        &>div:first-child {
            display: flex;
            align-items: center;
            padding-left: .2rem;
            position: absolute;
            height: 100%;
            left: 0;
            top: 0;
            z-index: 3;

            &>i {
                color: var(--aurora-muted);
                font-size: .48rem;
                margin-right: .14rem;
            }

            .logo {
                height: .48rem;
                width: auto;
                will-change: auto !important;
                cursor: pointer;
            }
        }

        .user_action {
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: relative;
            z-index: 2;
            margin: 0 auto;
            max-width: 1414px;
            min-width: 720px;
            padding-left: 32px;
            padding-right: 32px;
            width: 100%;

            .user_info {
                display: flex;
                align-items: center;
                // column-gap: 10px;
                font-size: .24rem;
                background: var(--aurora-soft-gradient);
                border: 1px solid var(--aurora-line);
                // padding: .01rem .15rem;
                // padding-right: .08rem;
                border-radius: .1rem;

                .CurrencyType {
                    background: var(--aurora-surface);
                    padding: .02rem;
                    border-radius: 50%;
                    flex-shrink: 0;
                    width: .36rem;
                    height: .36rem;
                    text-align: center;
                    line-height: .36rem;
                    color: var(--aurora-ink);
                    font-size: .23rem;
                }

                .user_account,
                .user_money {
                    // display: flex;
                    // align-items: center;
                    color: var(--aurora-ink);
                    // background: rgba(255, 255, 255, 0.15);
                    padding: 0 .08rem;
                    border-radius: .2rem;
                }

                .user_account {
                    color: var(--aurora-muted);
                }

                .icon-shuaxin {
                    font-size: .2rem;
                    color: var(--aurora-accent);
                }

                .deposit {
                    height: .6rem;
                    border-radius: .17rem;
                    background:
                        var(--aurora-primary-gradient);
                    color: var(--aurora-on-primary);
                    box-shadow: inset 0 1px 0 var(--aurora-shadow-color), 0 .08rem .16rem var(--aurora-shadow-color);
                    line-height: .6rem;
                    font-size: .5rem;
                    // margin-left: .1rem;

                    &.deposit_app {
                        display: none;
                        width: .6rem;
                    }

                    &.deposit_PC {
                        font-size: .25rem;
                        font-weight: bold;
                        padding: 0 .3rem;
                        text-transform: uppercase;
                        cursor: pointer;
                    }
                }
            }
        }
    }
}

html[data-device-nodesktop="1"] {
    .fixed-game-header {
        z-index: 100;

        .downApp {
            display: none;
        }
    }
}

.fixed-game-header {
    .pages-header {
        & > div:first-child > i {
            color: var(--aurora-accent);
        }
    }
}
</style>
